import { useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Outlet, useMatch } from "react-router";
import StepsBar from "./StepsBar";
import { useAppSelector } from "../../../services/hooks";
import { AnimatePresence } from "motion/react";
import SiteSummaryDetails from "./SiteSummary/SiteSummaryDetails.tsx";
import SiteSummaryCart from "./SiteSummary/SiteSummaryCart.tsx";
import SiteSummaryCheckout from "./SiteSummary/SiteSummaryCheckout.tsx";
import { CheckoutContext } from "../../../stores/cart/checkoutContext.ts";

export default function Layout() {
    const loaded = useAppSelector((state) => state.user.loaded)

    let SiteSummaryComponent = undefined;

    if (useMatch('/cart/checkout')) SiteSummaryComponent = SiteSummaryCheckout //React.lazy(() => import("./SiteSummary/SiteSummaryCheckout.tsx"));
    if (useMatch('/cart/summary/:hash')) SiteSummaryComponent = SiteSummaryDetails //React.lazy(() => import("./SiteSummary/SiteSummaryDetails.tsx"));
    if (SiteSummaryComponent === undefined) SiteSummaryComponent = SiteSummaryCart //React.lazy(() => import("./SiteSummary/SiteSummaryCart.tsx"));

    const [globalState, setGlobalState] = useState({
        billingFormRef: {},
        rulesRef: null,
        privacyRef: null,
    });

    const setSiteState = (state: object) => {
        setGlobalState(Object.assign(globalState, state));
    };

    if(!loaded) {
        return (
            <span/>
        );
    }

    return (
        loaded &&
        <Container className="py-2">
            <StepsBar />
            <Row className="py-1">
                <CheckoutContext.Provider value={{ globalState, setSiteState }}>
                    <Col xxl={8}>
                        <AnimatePresence>
                            <Outlet />
                        </AnimatePresence>
                    </Col>
                    <Col xxl={4}>
                        <SiteSummaryComponent />
                    </Col>
                </CheckoutContext.Provider>
            </Row>
        </Container>
    )
}